import { render } from "./WorkspaceMenu.vue?vue&type=template&id=c44f8900&ts=true"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=ts"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__